export default __webpack_public_path__ + "static/Years1996-b0b775c5aca04a11eea4e0369d5a0050.jpeg";